/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {Observable} from 'rxjs';
import {PartnerDetailModel} from '../contracts/partner-detail.model';
import {PartnerGroupBaseModel} from '../contracts/partner-group-base.model';
import {Cacheable} from '../../../decorators/cacheable.decorator';

@Injectable({
    providedIn: 'root'
})
export class PartnerService {
    // API endpoints
    public partnerDetailActiveUrl = `${environment.specialOrdersBaseUrl}/api/partner/detail/active`;
    public partnerBaseGroupByCountryUrl = `${environment.specialOrdersBaseUrl}/api/partner/base/groupBy/country`;

    constructor(protected http: HttpClient) {
    }

    @Cacheable()
    getPartnersOptions(): Observable<PartnerDetailModel[]> {
        return this.http.get<PartnerDetailModel[]>(this.partnerDetailActiveUrl);
    }

    @Cacheable()
    getPartnersGroupOptions(): Observable<PartnerGroupBaseModel[]> {
        return this.http.get<PartnerGroupBaseModel[]>(this.partnerBaseGroupByCountryUrl);
    }
}
